import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { Button } from './ui/button';

const OnlineStore = () => {
  return (
    <section id="loja-virtual" className="py-20 bg-slate-900 overflow-hidden" style={{ scrollMarginTop: '100px' }}>
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">Loja Virtual</h2>
          <p className="text-xl text-blue-300 mb-12">Acesse nossa loja online e conheça nossos produtos</p>
          
          <div className="flex justify-center">
            <a
              href="https://loja.fernandotech.com.br/"
              target="_blank"
              rel="noopener noreferrer"
              className="group"
            >
              <div className="relative">
                {/* Círculo de fundo com gradiente */}
                <div className="w-48 h-48 md:w-64 md:h-64 rounded-full bg-gradient-to-br from-blue-600 to-cyan-500 flex items-center justify-center shadow-2xl shadow-blue-500/50 transition-all duration-300 group-hover:scale-110 group-hover:shadow-cyan-500/70">
                  <ShoppingCart size={80} className="text-white md:w-32 md:h-32" strokeWidth={1.5} />
                </div>
                
                {/* Pulso animado */}
                <div className="absolute inset-0 rounded-full bg-gradient-to-br from-blue-600 to-cyan-500 animate-ping opacity-20"></div>
              </div>
              
              <Button
                size="lg"
                className="mt-8 bg-gradient-to-r from-blue-600 to-cyan-500 hover:from-blue-700 hover:to-cyan-600 text-white font-semibold px-8 sm:px-12 py-6 text-lg shadow-2xl shadow-blue-500/50 hover:shadow-cyan-500/50 transition-all duration-300 hover:scale-105"
              >
                Acessar Loja Virtual
              </Button>
            </a>
          </div>
          
          <p className="mt-8 text-gray-400 text-sm">
            Equipamentos, componentes e soluções em TI
          </p>
        </div>
      </div>
    </section>
  );
};

export default OnlineStore;
